import { DataBean } from "../DataBean";



export class PaymentHeader extends DataBean {

    public async getPaymentHeaderCatalog(idProcess:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getPaymentHeaderCatalog_Number", [idProcess]);
    }

    public async getPaymentHeaderProperties(idBudgetAccountantOperation:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.Map_getPaymentHeaderProperties_Number", [idBudgetAccountantOperation]);
    }

    public async createPaymentHeader(idProcess:any,values:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.budgetaccountant.PaymentHeader_createPaymentHeader_Number_java.util.Map", [idProcess,values]);
    }

    public async getProcess(idProcess:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "admin.Process_getProcess_Number",
             [idProcess]);
    }
    public async executeBudgetAccountantOperation(idProcess:any,processDate:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "String_executeBudgetAccountantOperation_Number_java.util.Date",
             [idProcess,processDate]);
    }
    public async getPaymentHeaderCatalogvdos(idProcess:any,processDate:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getPaymentHeaderCatalog_Number_java.util.Date", [idProcess,processDate]);

    }
    


}